import React, { useState, useEffect, useRef } from 'react';
import { ShoppingCart, X, Plus, Minus, Trash2, Menu } from 'lucide-react';



const products = [
  { id: 1, name: "ESPRESSO", price: 299, image: "https://images.unsplash.com/photo-1510591509098-f4fdc6d0ff04?w=800" },
  { id: 2, name: "SIGNATURE", price: 399, image: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=800" },
  { id: 3, name: "CAPPUCCINO", price: 349, image: "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=800" }
];

const App = () => {
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [addedId, setAddedId] = useState(null);
  
  // Refs for tracking position of each section
  const heroRef = useRef(null);
  const originRef = useRef(null);
  const brewRef = useRef(null);
  const shopRef = useRef(null);

  useEffect(() => {
    const savedCart = localStorage.getItem('coffeeCart');
    if (savedCart) setCart(JSON.parse(savedCart));
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    localStorage.setItem('coffeeCart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
  setCart(prev => {
    const existing = prev.find(item => item.id === product.id);
    if (existing) {
      return prev.map(item => 
        item.id === product.id ? {...item, quantity: item.quantity + 1} : item
      );
    }
    return [...prev, {...product, quantity: 1}];
  });

  setAddedId(product.id);

  // Button reset after 1.5s
  setTimeout(() => setAddedId(null), 1500);
};

  const updateQuantity = (id, delta) => {
    setCart(prev => prev.map(item => 
      item.id === id ? {...item, quantity: Math.max(1, item.quantity + delta)} : item
    ));
  };

  const removeFromCart = (id) => {
    setCart(prev => prev.filter(item => item.id !== id));
  };

  const totalAmount = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCheckout = () => {
    const options = {
      key: "rzp_test_1DP5mmOlF5G5ag",
      amount: totalAmount * 100,
      currency: "INR",
      name: "YOGI BREW",
      description: "Premium Coffee Purchase",
      handler: function(response) {
        alert(`Payment Successful! ID: ${response.razorpay_payment_id}`);
        setCart([]);
        setShowCart(false);
      },
      prefill: {
        name: "Customer Name",
        email: "customer@example.com",
        contact: "9999999999"
      },
      theme: { color: "#8B4513" }
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  // FADE CALCULATION FUNCTION
  // This calculates opacity/scale based on how much the section has been scrolled past
  const getScrollStyles = (ref) => {
    if (!ref.current || window.innerWidth <= 768) return { opacity: 1, transform: 'none' };
    const rect = ref.current.getBoundingClientRect();
    const scrollFactor = Math.abs(rect.top) / 500;
    const opacity = rect.top <= 0 ? Math.max(0, 1 - scrollFactor) : 1;
    const scale = rect.top <= 0 ? Math.max(0.9, 1 - scrollFactor / 5) : 1;
    return { opacity, transform: `scale(${scale})` };
  };

  const heroStyles = getScrollStyles(heroRef);
  const originStyles = getScrollStyles(originRef);
  const brewStyles = getScrollStyles(brewRef);

  return (
    <div style={{
      fontFamily: 'system-ui, -apple-system, sans-serif',
      backgroundColor: '#0a0a0a',
      color: '#fff',
      minHeight: '100vh',
    }}>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { overflow-x: hidden; }
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #1a1a1a; }
        ::-webkit-scrollbar-thumb { background: #8B4513; border-radius: 4px; }

        .nav-links { display: flex; gap: 40px; align-items: center; }
        .hamburger { display: none; cursor: pointer; z-index: 2001; background: none; border: none; color: white; }

        @media (max-width: 768px) {
          .nav-links { display: none; }
          .hamburger { display: block; }
          .hero-title { font-size: 55px !important; letter-spacing: 10px !important; }
          .nav-container { padding: 15px 20px !important; }
          .origin-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .brew-card-container { height: 280px !important; }
          .brew-img { top: -30px !important; }
          .origin-img-container { height: 350px !important; }
        }

        .mobile-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          background: #0a0a0a;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 30px;
          z-index: 2000;
          transition: transform 0.6s cubic-bezier(0.85, 0, 0.15, 1);
          transform: translateY(${isMenuOpen ? '0' : '-100%'});
        }
        .mobile-menu-overlay a {
          color: #fff;
          text-decoration: none;
          font-size: 28px;
          letter-spacing: 5px;
        }
      `}</style>

      {/* Mobile Premium Menu Overlay */}
      <div className="mobile-menu-overlay">
        <button style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', color: 'white' }} onClick={() => setIsMenuOpen(false)}>
          <X size={32} />
        </button>
        <a href="#origin" onClick={() => setIsMenuOpen(false)}>ORIGIN</a>
        <a href="#roastery" onClick={() => setIsMenuOpen(false)}>ROASTERY</a>
        <a href="#brew" onClick={() => setIsMenuOpen(false)}>BREW</a>
        <a href="#shop" onClick={() => setIsMenuOpen(false)}>SHOP</a>
      </div>

      <nav className="nav-container" style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 50px',
        zIndex: 1001,
        background: scrollY > 50 ? 'rgba(10,10,10,0.95)' : 'transparent',
        backdropFilter: scrollY > 50 ? 'blur(10px)' : 'none',
        transition: 'all 0.3s'
      }}>
        <div style={{fontSize: '24px', fontWeight: 'bold', letterSpacing: '3px'}}>YOGI BREW</div>
        <div style={{display: 'flex', gap: '20px', alignItems: 'center'}}>
          <div className="nav-links">
            <a href="#home" style={{color: '#fff', textDecoration: 'none', fontSize: '14px', letterSpacing: '1px'}}>HOME</a>
            <a href="#origin" style={{color: '#fff', textDecoration: 'none', fontSize: '14px', letterSpacing: '1px'}}>ORIGIN</a>
            <a href="#brew" style={{color: '#fff', textDecoration: 'none', fontSize: '14px', letterSpacing: '1px'}}>BREW</a>
            <a href="#shop" style={{color: '#fff', textDecoration: 'none', fontSize: '14px', letterSpacing: '1px'}}>SHOP</a>
          </div>
          <button onClick={() => setShowCart(true)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', position: 'relative', padding: '8px' }}>
            <ShoppingCart size={24} />
            {totalItems > 0 && (
              <span style={{ position: 'absolute', top: '0', right: '0', background: '#8B4513', borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 'bold' }}>{totalItems}</span>
            )}
          </button>
          <button className="hamburger" onClick={() => setIsMenuOpen(true)}><Menu size={28} /></button>
        </div>
      </nav>

      {/* HERO SECTION */}
      <div id='home' ref={heroRef} style={{
        height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden',
        opacity: heroStyles.opacity, transform: heroStyles.transform, transition: 'opacity 0.1s, transform 0.1s'
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url(https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=1920)', backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.4 }} />
        <div style={{ textAlign: 'center', zIndex: 10 }}>
          <h1 className="hero-title" style={{fontSize: '120px', fontWeight: '300', letterSpacing: '20px', marginBottom: '20px'}}>YOGI BREW</h1>
          <p className="hero-subtitle" style={{fontSize: '18px', letterSpacing: '5px', color: '#aaa'}}>ARTISAN COFFEE ROASTERS</p>
        </div>
      </div>

      {/* ORIGIN SECTION */}
      <div id="origin" ref={originRef} style={{
        minHeight: '100vh', padding: '140px 6vw', background: 'linear-gradient(180deg, #0a0a0a 0%, #120b08 100%)', display: 'flex', alignItems: 'center',
        opacity: originStyles.opacity, transform: originStyles.transform, transition: 'opacity 0.1s, transform 0.1s'
      }}>
        <div style={{ maxWidth: '1300px', margin: '0 auto', width: '100%' }}>
          <h2 style={{ fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: '300', letterSpacing: '10px', textAlign: 'center', marginBottom: '80px' }}>OUR ORIGIN</h2>
          <div className="origin-grid" style={{ display: 'grid', gridTemplateColumns: '1.1fr 1fr', gap: '80px', alignItems: 'center' }}>
            <div>
              <h3 style={{ color: '#8B4513', letterSpacing: '4px', marginBottom: '25px', fontSize: '14px' }}>EST. 1938</h3>
              <p style={{ color: '#ccc', lineHeight: '1.9', fontSize: 'clamp(20px, 1.4vw, 24px)', marginBottom: '30px' }}>Deep in the highlands, where the mist kisses the soil, we hand-select only the finest coffee cherries grown under slow sun and rich earth. Sourced from Ethiopia’s highlands at 2,000m, these heirloom beans are sun-dried on raised beds and gently roasted in micro-batches to unlock layered, nuanced flavors.</p>
              <p style={{ color: '#aaa', lineHeight: '1.9', fontSize: 'clamp(16px, 1.2vw, 20px)' }}>Our journey began with a simple promise — to preserve the authentic soul of the bean, honoring generations of farmers and craftsmanship.</p>
            </div>
            <div className="origin-img-container" style={{ position: 'relative', height: '520px', borderRadius: '4px', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url(https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=1200)', backgroundSize: 'cover', backgroundPosition: 'center', filter: 'grayscale(0.4)' }} />
            </div>
          </div>
        </div>
      </div>

      {/* BREW SECTION */}
      <div id="brew" ref={brewRef} style={{
  padding: '120px 5vw', 
  background: '#0f0f0f', 
  overflow: 'hidden',
  opacity: brewStyles.opacity, 
  transform: brewStyles.transform, 
  transition: 'opacity 0.1s, transform 0.1s'
}}>
  <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
    <h2 style={{ fontSize: '40px', fontWeight: '300', letterSpacing: '12px', marginBottom: '80px', textAlign: 'center' }}>BREW METHODS</h2>
    <p style={{ fontSize: '21px', lineHeight: '1.8', color: '#ccc', maxWidth: '800px', margin: '0 auto 100px', textAlign: 'center' }}>Sourced from Ethiopia’s highlands at 2,000m, these heirloom beans are sun-dried on raised beds and gently roasted in micro-batches to unlock layered, nuanced flavors.</p>
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
      gap: '80px' 
    }}>
      {[
        { name: "LATTE ART", img: "https://www.nescafe.com/in/sites/default/files/2023-08/Nes_Web3_Article_Header_Latte_1448x1240.png" },
        { name: "MOCHA", img: "https://www.nescafe.com/in/sites/default/files/2023-08/Nes_Web3_Article_Header_Mocha_1448x1240.png" },
        { name: "AMERICANO", img: "https://www.nescafe.com/in/sites/default/files/2023-08/Nes_Web3_Article_Header_Americano_1448x1240.png" }
      ].map((method, index) => (
        <div key={index} style={{ perspective: '1000px' }}>
          <div 
            className="brew-card-container" 
            style={{ 
              position: 'relative', 
              width: '100%', 
              height: '350px', // Exact height from your request
              transition: 'transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)', 
              transformStyle: 'preserve-3d', 
              cursor: 'pointer' 
            }}
            onMouseEnter={e => e.currentTarget.style.transform = 'rotateX(45deg) translateY(-20px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'rotateX(0deg) translateY(0)'}
          >
            {/* The White Square (Card Base) */}
            <div style={{ 
              position: 'absolute', 
              inset: 0, 
              background: '#fff', 
              borderRadius: '8px', 
              boxShadow: '0 20px 50px rgba(0,0,0,0.5)' 
            }} />

            {/* The Image (Upright and Large) */}
            <div 
              className="brew-img" 
              style={{ 
                position: 'absolute', 
                top: '-50px', 
                left: '5%', 
                width: '90%', 
                height: '100%', 
                backgroundImage: `url(${method.img})`, 
                backgroundSize: 'contain', 
                backgroundRepeat: 'no-repeat', 
                backgroundPosition: 'center', 
                transform: 'translateZ(80px) rotateX(-45deg)', // Counter-rotation stays straight
                transition: 'transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)',
                filter: 'drop-shadow(0 15px 15px rgba(0,0,0,0.3))'
              }} 
            />

            {/* Title Overlay */}
            <div style={{ 
              position: 'absolute', 
              bottom: '25px', 
              width: '100%', 
              textAlign: 'center', 
              transform: 'translateZ(40px)', 
              color: '#000' 
            }}>
              <h4 style={{ letterSpacing: '4px', fontSize: '16px', fontWeight: 'bold' }}>{method.name}</h4>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
      {/* SHOP SECTION */}
      {/* SHOP SECTION - With Brown Shiny Shadow Glow */}
<div 
  id="shop" 
  ref={shopRef} 
  style={{ 
    minHeight: '100vh', 
    background: 'linear-gradient(to bottom, #0a0a0a, #1a1010)', 
    padding: '100px 50px',
    opacity: window.innerWidth > 768 ? Math.max(0, 1 - Math.abs(shopRef.current?.getBoundingClientRect().top || 0) / 1000) : 1,
    transform: window.innerWidth > 768 ? `scale(${Math.max(0.95, 1 - Math.abs(shopRef.current?.getBoundingClientRect().top || 0) / 5000)})` : 'none',
    transition: 'opacity 0.1s, transform 0.1s'
  }}
>
  <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
    <h2 style={{ fontSize: '52px', fontWeight: '400', letterSpacing: '10px', marginBottom: '50px', textAlign: 'center' }}>
      The Golden Roast
    </h2>
    <p style={{ fontSize: '22px', lineHeight: '1.8', color: '#ccc', maxWidth: '800px', margin: '0 auto 100px', textAlign: 'center' }}>
      Crafted from Ethiopian heirloom varietals grown at 2,000m elevation. Sun-dried on raised African beds, 
      then roasted in micro-batches over beechwood fires.
    </p>

    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
      gap: '40px' 
    }}>
      {products.map(product => (
        <div 
          key={product.id} 
          style={{ 
            background: 'rgba(255,255,255,0.03)', 
            borderRadius: '10px', 
            overflow: 'hidden', 
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)', // Smooth pop effect
            cursor: 'pointer',
            border: '1px solid rgba(255,255,255,0.05)'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-15px)';
            // Brown Shiny Shadow Glow Effect
            e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 69, 19, 0.4), 0 0 20px rgba(139, 69, 19, 0.2)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <div style={{ 
            height: '300px', 
            backgroundImage: `url(${product.image})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center' 
          }} />
          
          <div style={{ padding: '30px' }}>
            <h3 style={{ fontSize: '24px', letterSpacing: '3px', marginBottom: '15px' }}>
              {product.name}
            </h3>
            <p style={{ fontSize: '28px', color: '#8B4513', fontWeight: 'bold', marginBottom: '20px' }}>
              ₹{product.price}
            </p>
            <button 
  onClick={() => addToCart(product)} 
  style={{ 
    width: '100%', 
    padding: '15px', 
    background: addedId === product.id ? '#2e1a10' : '#8B4513',
    border: 'none', 
    color: '#fff', 
    fontSize: '14px', 
    letterSpacing: '2px', 
    cursor: 'pointer', 
    borderRadius: '5px',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    transform: addedId === product.id ? 'scale(0.97)' : 'scale(1)'
  }}
>
  {addedId === product.id ? 'ADDED ✓' : 'ADD TO CART'}
</button>

          </div>
        </div>
      ))}
    </div>
  </div>
</div>

      {/* CART OVERLAY (SAME AS BEFORE) */}
      {showCart && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 2005, display: 'flex', justifyContent: 'flex-end' }} onClick={() => setShowCart(false)}>
          <div style={{ width: '450px', maxWidth: '85vw', background: '#1a1a1a', height: '100vh', padding: '30px', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
             <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px'}}>
              <h2 style={{fontSize: '22px', letterSpacing: '2px'}}>YOUR CART</h2>
              <button onClick={() => setShowCart(false)} style={{ background: 'none', border: 'none', color: '#fff' }}><X size={24} /></button>
            </div>
            {cart.map(item => (
              <div key={item.id} style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '8px', marginBottom: '10px' }}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <p style={{fontSize: '14px'}}>{item.name}</p>
                  <button onClick={() => removeFromCart(item.id)} style={{background: 'none', border: 'none', color: '#ff4444'}}><Trash2 size={16}/></button>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px', alignItems: 'center'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <button onClick={() => updateQuantity(item.id, -1)} style={{width: '25px', height: '25px', background: '#333', border: 'none', color: '#fff'}}><Minus size={14}/></button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, 1)} style={{width: '25px', height: '25px', background: '#333', border: 'none', color: '#fff'}}><Plus size={14}/></button>
                  </div>
                  <p>₹{item.price * item.quantity}</p>
                </div>
              </div>
            ))}
            {cart.length > 0 && (
              <div style={{marginTop: '30px', borderTop: '1px solid #333', paddingTop: '20px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 'bold'}}>
                  <span>TOTAL</span><span>₹{totalAmount}</span>
                </div>
                <button onClick={handleCheckout} style={{ width: '100%', padding: '15px', background: '#8B4513', color: '#fff', border: 'none', marginTop: '20px', borderRadius: '5px', fontWeight: 'bold' }}>CHECKOUT</button>
              </div>
            )}
          </div>
        </div>
      )}



      {/* PREMIUM GLOSSY FOOTER */}
<footer style={{
  background: '#050505',
  padding: '100px 5vw 40px',
  position: 'relative',
  overflow: 'hidden',
  borderTop: '1px solid rgba(139, 69, 19, 0.2)'
}}>
  {/* Glossy Decorative Element */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    height: '1px',
    background: 'linear-gradient(90deg, transparent, #8B4513, transparent)',
    boxShadow: '0 0 20px #8B4513'
  }} />

  <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '60px',
      marginBottom: '80px'
    }}>
      
      {/* Brand Column */}
      <div style={{ flex: 1 }}>
        <h2 style={{ fontSize: '28px', fontWeight: 'bold', letterSpacing: '5px', marginBottom: '25px' }}>YOGI BREW</h2>
        <p style={{ color: '#666', lineHeight: '1.8', fontSize: '15px', maxWidth: '300px' }}>
          Crafting the perfect cup since 1938. From the misty highlands to your morning ritual, we bring the soul of the bean to life.
        </p>
      </div>

      {/* Links Column */}
      <div>
        <h4 style={{ color: '#8B4513', letterSpacing: '3px', marginBottom: '25px', fontSize: '14px' }}>NAVIGATE</h4>
        <ul style={{ listStyle: 'none' }}>
          {['HOME','ORIGIN', 'BREW', 'SHOP'].map((item) => (
            <li key={item} style={{ marginBottom: '15px' }}>
              <a href={`#${item.toLowerCase()}`} className="footer-link" style={{
                color: '#aaa',
                textDecoration: 'none',
                fontSize: '14px',
                letterSpacing: '1px',
                transition: 'all 0.3s ease'
              }}>{item}</a>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact Column */}
      <div>
        <h4 style={{ color: '#8B4513', letterSpacing: '3px', marginBottom: '25px', fontSize: '14px' }}>CONNECT</h4>
        <p style={{ color: '#aaa', fontSize: '14px', marginBottom: '10px' }}>Highlands Avenue, Roastery Row</p>
        <p style={{ color: '#aaa', fontSize: '14px', marginBottom: '10px' }}>hello@yogibrew-artisan.com</p>
        <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
          {/* Social Icons Placeholder */}
          {[1, 2, 3].map(i => (
            <div key={i} style={{
              width: '35px', height: '35px', borderRadius: '50%', border: '1px solid #333',
              display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
              transition: '0.3s'
            }} onMouseEnter={e => e.currentTarget.style.borderColor = '#8B4513'}>
              <div style={{ width: '4px', height: '4px', background: '#8B4513', borderRadius: '50%' }} />
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Bottom Bar */}
    <div style={{
      borderTop: '1px solid #1a1a1a',
      paddingTop: '40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '20px'
    }}>
      <p style={{ color: '#444', fontSize: '12px', letterSpacing: '2px' }}>
        © 2025 YOGI BREW ARTISAN. ALL RIGHTS RESERVED.
      </p>
      <div style={{ display: 'flex', gap: '30px' }}>
        <span style={{ color: '#444', fontSize: '11px', letterSpacing: '1px', cursor: 'pointer' }}>PRIVACY</span>
        <span style={{ color: '#444', fontSize: '11px', letterSpacing: '1px', cursor: 'pointer' }}>TERMS</span>
      </div>
    </div>
  </div>

  <style>{`
    .footer-link:hover {
      color: #8B4513 !important;
      padding-left: 10px;
    }
    footer {
      /* Subtle glossy animation background */
      background: radial-gradient(circle at 50% -20%, #1a1010 0%, #050505 100%);
    }
  `}</style>
</footer>


    </div>
  );
};

export default App;